// extracted by mini-css-extract-plugin
export default {"button":"ButtonModal_button__XpMgA"};